import { Check, ShieldCheck, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface TrustBadgesCompactProps {
  variant?: 'light' | 'dark';
  className?: string;
}

export const TrustBadgesCompact = ({ variant = 'light', className }: TrustBadgesCompactProps) => {
  const { t } = useTranslation();

  const badges = [
    { 
      icon: Check, 
      text: t('trustBadgesCompact.trial'),
      highlighted: true 
    },
    { 
      icon: ShieldCheck, 
      text: t('trustBadgesCompact.secure') 
    },
    { 
      icon: X, 
      text: t('trustBadgesCompact.cancel') 
    },
  ];

  return (
    <div className={cn(
      "flex items-center justify-center gap-1.5 flex-wrap mt-3 animate-fade-in",
      className
    )}>
      {badges.map((item, index) => (
        <>
          <div
            key={index}
            className={cn(
              "flex items-center gap-1 transition-all duration-200 group cursor-default",
              "px-2 py-1 rounded-full border border-white/10",
              "hover:scale-[1.02] hover:border-white/20"
            )}
          >
            <item.icon className={cn(
              "w-3 h-3 flex-shrink-0 transition-opacity duration-200",
              item.highlighted 
                ? "text-newsletter-accent/70 group-hover:text-newsletter-accent/90"
                : "text-white/50 group-hover:text-white/60"
            )} />
            <span className={cn(
              "whitespace-nowrap text-[11px] font-medium transition-opacity duration-200",
              item.highlighted
                ? "text-newsletter-accent/80 group-hover:text-newsletter-accent"
                : "text-white/60 group-hover:text-white/80"
            )}>
              {item.text}
            </span>
          </div>
          
          {/* Separador entre badges */}
          {index < badges.length - 1 && (
            <span className="text-white/30 text-[10px]">•</span>
          )}
        </>
      ))}
    </div>
  );
};
